import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

Blog01.propTypes = {};

function Blog01(props) {
  const { data } = props;
  const { className } = props;
  return (
    <section className={className}>
      <div className="tf-container">
        <div className="row">
          {data.length !== 0 ? (
            <div className="col-md-12">
              <div className="tf-title style-2 style-4">
                <div className="group-title">
                  <h1>Related Articles</h1>
                </div>
              </div>
            </div>
          ) : null}
          {data.slice(0, 3).map((idx) => (
            <div key={idx.id} className="col-lg-4 wow fadeInUp">
              <div className="box-latest">
                <div className="img-latest">
                  <img src={idx.bannerImage} alt="Jobtex" />
                </div>
                <div className="box-content">
                  <div className="heading">
                    <Link to="#" className="tag">
                      {idx.category}
                    </Link>
                    <h3>
                      <Link to={`/news/${idx.slug}`}> {idx.title}</Link>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Blog01;
